import { useSyncExternalStore } from 'react'
import { LayoutEvent } from '../../constants/enums'
import { pubSubLayout } from '../../state/pubSub'
import { LAYOUTSTATE, TPortalState } from '../../state/state.layout'

const subPortal = (callback) =>
    pubSubLayout.on(LayoutEvent.PORTAL_CHANGE, callback)
const getPortalSelector = (attribute) => () => LAYOUTSTATE.portal[attribute]

export const usePortalStateSelector = <T extends keyof TPortalState>(
    attribute: T,
): TPortalState[T] => {
    return useSyncExternalStore(
        subPortal,
        getPortalSelector(attribute),
        getPortalSelector(attribute),
    )
}
